import { createStore } from 'vuex'
import createPersistedState from "vuex-persistedstate";

export default createStore({
  state: {
    isGetterRouter: false,// 是否添加路由
    isCollapse: false,// 是否折叠菜单
    userInfo: {},// 用户信息
    // 企业认证审核角标
    enterpriseState: {
      hidden: true,
      total: 0
    },
    // 手动退款角标
    refundState: {
      hidden: true,
      total: 0
    },
    // 售车信息角标
    sellState: {
      hidden: true,
      total: 0
    },
    // 求购车源信息角标
    buyState: {
      hidden: true,
      total: 0
    }
  },
  getters: {
  },
  mutations: {
    changeGetterRouter(state, value) {
      state.isGetterRouter = value;
    },
    // 折叠菜单
    changeCollapse(state) {
      state.isCollapse = !state.isCollapse;
    },
    // 用户信息赋值
    changeUserInfo(state, value) {
      state.userInfo = {
        ...state.userInfo,
        ...value,
      };
    },
    // 清空用户信息
    clearUserInfo(state) {
      state.userInfo = {};
    },
    // 企业认证审核
    changeentErpriseState(state, total) {
      state.enterpriseState = {
        hidden: total == 0 ? true : false,
        total: total
      };
    },
    // 修改手动退款状态
    changeRefundState(state, total) {
      state.refundState = {
        hidden: total == 0 ? true : false,
        total: total
      };
    },
    // 修改售车信息状态
    changeSellState(state, total) {
      state.sellState = {
        hidden: total == 0 ? true : false,
        total: total
      };
    },
    // 修改求购车源信息状态
    changeBuyState(state, total) {
      state.buyState = {
        hidden: total == 0 ? true : false,
        total: total
      };
    },
  },
  actions: {
  },
  modules: {
  },
  plugins: [createPersistedState({
    paths: ["isCollapse", "userInfo"]
  })],
})
